module.exports = __webpack_public_path__ + "img/btn_power1_n.2b362b8c.png";